/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui';


/* ++++++++++ --------------- SENTIMENT ADVANCED SETTINGS - ADVANCED CONFIGS : STYLES --------------- ++++++++++ */
export default {
    authenticationconfig: {
        '& .message': {
            marginTop: pxToEm(20),
            marginBottom: pxToEm(30)
        }
    },
    SelectField: {
        '& .select':{
        // background: 'none',
        // marginLeft: '4em',
        // float: 'right',
        color: 'rgb(20, 148, 244)',
        fontSize: '1.2em',
        fontWeight: '500',
        border: '1px solid rgba(178, 193, 230, 0.3)',
        minWidth: '10em',
        width: '100%',
        padding: '.75em 1em',
        borderRadius: pxToEm(13.5),
        background:
            'linear-gradient(45deg, transparent 50%, #ccc 50%),' +
            'linear-gradient(135deg, #ccc 50%, transparent 50%)',
        backgroundPosition:
            'calc(100% - 20px) calc(1em + 7px), ' +
            'calc(100% - 15px) calc(1em + 7px),' +
            '0% 0',
        backgroundSize: '5px 5px,5px 5px,1px 1.5em',
        backgroundRepeat: 'no-repeat',
        margin: 0,
        '-webkit-box-sizing': 'border-box',
        '-moz-box-sizing': 'border-box',
        'box-sizing': 'border-box',
        '-webkit-appearance': 'none',
        '-moz-appearance': 'none',},
        '& button':{
            width: 'auto',
            marginLeft: '1em',
            padding: '0 2em'
        }
    },
};
